module.exports = __webpack_public_path__ + "static/media/github.ff1d322d.png";